//for production
export function lesMisPipe() { 
    throw new Error('lesMisPipe not implemented; using dev webpack')
}
export function lesMisOpen() { 
    throw new Error('lesMisOpen not implemented; using dev webpack')
}
export function chainCycleOpen() {
    throw new Error('chainCycleOpen not implemented; using dev webpack')
}
export function chainCyclePipe() {
    throw new Error('chainCyclePipe not implemented; using dev webpack')
}
// baked-corpus registry (see stubs.js); only reachable in STUB_DEPENDENCIES builds,
// which never alias to this module — production builds must not embed the corpus
export const bakedRegistry = {};
export function resolveBakedName() {
    return null;
}
export function bakedOpen() {
    throw new Error('bakedOpen not implemented; using dev webpack')
}
export function bakedPipe() {
    throw new Error('bakedPipe not implemented; using dev webpack')
}

//fetcher("/streamgl/open?id=a4c86905eedb4218826d68838ec297f7", temp1)
//https://developer.mozilla.org/en-US/docs/Web/API/Streams_API/Using_readable_streams
export function fetcher(uri, opts) {
    const v = fetch(uri, opts);
    var r = v.body.getReader();
    var s = new ReadableStream({
        start(controller) {
            function push() {
                return r.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;
                    }
        
                    controller.enqueue(value);
                    push();
                });
            };
            push();
        }
        });
    var resp = new Response(s);
    var b = resp.blob();
    return b.then(bb => {
        console.debug('fetcher blob', {uri, opts, bb});
        return bb;
    });
}
window.fetcher = fetcher;


//Use to dump buffer from an arbitrary session
//printSessionBuffer("160ae2d2b4764e67ad4bde70251d28a5") => console.log("new Uint8Array([...])")
export function printSessionBuffer(session) {
    
    const uri = `/streamgl/open?id=${session}`;
    const formStr = `id=${session}&v=0&layoutOptions%5Bgravity%5D=0.10471285480508996&layoutOptions%5BlinLog%5D=false&layoutOptions%5BlockedX%5D=false&layoutOptions%5BlockedY%5D=false&layoutOptions%5BlockedR%5D=false&layoutOptions%5BscalingRatio%5D=0.10471285480508996&layoutOptions%5BedgeInfluence%5D=0&layoutOptions%5BdissuadeHubs%5D=false&layoutOptions%5BstrongGravity%5D=false&layoutOptions%5BprecisionVsSpeed%5D=-0.1&filtered=true`; 
    const opts = {
        'method': 'POST',
        'headers': {
          'content-type': 'application/x-www-form-urlencoded'
        },
        body: formStr
    };
    return fetch(uri, opts).then(
        function(v) {
            var r = v.body.getReader();
            var s = new ReadableStream({
                start(controller) {
                    function push() {
                    return r.read().then(({ done, value }) => {
                        console.log('push then', {done, value});
                        if (done) {
                            controller.close();
                            return;
                        }
                        controller.enqueue(value);
                        push();
                    });
                    };        
                    push();
                }
                });
            var resp = new Response(s);
            var b = resp.blob();
            return b.then(bb => {
                console.debug('fetcher blob', {uri, opts, bb});
                return (new Response(bb)).arrayBuffer().then(
                    function (bb) {
                        console.debug('fetcher arraybuffer', bb);
                        const asStr = JSON.stringify(Array.from(new Uint8Array(bb)));
                        console.debug('fetcher arraybuffer as string', `new Uint8Array(${asStr})`);
                        return bb;
                    });
            });
    })
}
window.printSessionBuffer = printSessionBuffer;
  